/**
 * Single source of truth for C444 app facts (Hero + JSON-LD + anywhere else).
 * Jab asli APK / listing change ho, sirf yahan values update karen.
 */
export const C444_APP_DISPLAY_NAME = "C444";
export const C444_APP_FILE_SIZE = "85.4 MB";

/** schema.org softwareVersion (semver-style text, no "v" prefix) */
export const C444_APP_SOFTWARE_VERSION = "1.2";

/** Hero VERSION card */
export const C444_APP_VERSION_DISPLAY = `v${C444_APP_SOFTWARE_VERSION} (Latest)`;

export const C444_APP_DOWNLOADS_DISPLAY = "500K+";

export const C444_APP_CATEGORY_DISPLAY = "Slots, Live";
export const C444_APP_DEVELOPER_DISPLAY = "C444 Team";

/** Hero RATING card */
export const C444_APP_RATING_DISPLAY = "4.9+";

/** schema.org aggregateRating.ratingValue */
export const C444_APP_RATING_VALUE = "4.9";

/** Minimum Android — Hero REQUIRES card + JSON-LD softwareRequirements */
export const C444_APP_MIN_ANDROID = "Android 5.0+";

/**
 * Active players stat (Hero promo box).
 * JSON-LD aggregateRating ratingCount/reviewCount is kept numerically equal
 * to this count so published numbers stay in sync (update both use cases together).
 */
export const C444_APP_ACTIVE_PLAYERS_COUNT = 85492;

export function c444FormatIntegerCount(n: number): string {
  return n.toLocaleString("en-US");
}

export const C444_APP_RATING_COUNT_FOR_SCHEMA = String(
  C444_APP_ACTIVE_PLAYERS_COUNT,
);
